export const getTabbableElements = (element) => {
    const tabbableElements = element.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
    return Array.from(tabbableElements).filter((tabbableElement) => {
        // Disabled elements are not tabbable
        const isDisabled = tabbableElement.hasAttribute('disabled');
        // Hidden elements are not tabbable
        const isHidden = tabbableElement.hasAttribute('hidden') || tabbableElement.hasAttribute('aria-hidden');
        return !isDisabled && !isHidden;
    });
};
//# sourceMappingURL=getTabbableElements.js.map